let toFixed2 = (value) => {
    if (!value && value != 0) {
        return '--'
    }
    return (value / 100).toFixed(2)
};
export {
  toFixed2,
}